import dbList from "../DBList.json";

const {
    api_server,
    general_registry
} = dbList.server;

export async function FetchGeneralRegistry() {
    const httpRes = await fetch(`${api_server}${general_registry}`, {
        method: "GET",
        mode: "cors",
        credentials: "include",
        headers: { "accept": "*/*" }
    });

    if (httpRes.status === 401) {
        // logout user
        throw {
            status: httpRes.status,
            message: await httpRes.text()
        };
    } else if (httpRes.status !== 200) {
        throw {
            status: httpRes.status,
            message: await httpRes.text()
        };
    }

    const result = await httpRes.json();

    if (result.status !== undefined && result.message !== undefined) {
        throw {
            status: 200,
            message: result.message
        };
    }

    return result;
}

export async function GetRegistry(AId) {
    const httpRes = await fetch(`${api_server}${general_registry}/get/${AId}`, {
        method: "GET",
        mode: "cors",
        credentials: "include",
        headers: { "accept": "*/*" }
    });

    if (httpRes.status === 401) {
        // logout user
        throw {
            status: httpRes.status,
            message: await httpRes.text()
        };
    } else if (httpRes.status !== 200) {
        throw {
            status: httpRes.status,
            message: await httpRes.text()
        };
    }

    const result = await httpRes.json();

    if (result.status !== undefined && result.message !== undefined) {
        throw {
            status: 200,
            message: result.message
        };
    }

    return result;
}

export async function DeleteRegistry(AId) {
    const httpRes = await fetch(`${api_server}${general_registry}/${AId}`, {
        method: "DELETE",
        mode: "cors",
        credentials: "include",
        headers: { "accept": "*/*" }
    });

    if (httpRes.status === 401) {
        // logout user
        throw {
            status: httpRes.status,
            message: await httpRes.text()
        };
    } else if (httpRes.status !== 200) {
        throw {
            status: httpRes.status,
            message: await httpRes.text()
        };
    }
}

export async function AddRegistry(ARegistry) {
    const httpRes = await fetch(`${api_server}${general_registry}`, {
        method: "PUT",
        mode: "cors",
        credentials: "include",
        headers: { 
            "accept": "*/*",
            "content-type" : "application/json"
        },
        body: JSON.stringify(ARegistry)
    });

    if (httpRes.status === 401) {
        // logout user
        throw {
            status: httpRes.status,
            message: await httpRes.text()
        };
    } else if (httpRes.status !== 200) {
        throw {
            status: httpRes.status,
            message: await httpRes.text()
        };
    }

    const result = await httpRes.json();

    if (result.status !== undefined && result.status !== null) {
        throw new Error(result.message);
    }
}

export async function UpdateRegistry(ARegistry) {
    const httpRes = await fetch(`${api_server}${general_registry}`, {
        method: "POST",
        mode: "cors",
        credentials: "include",
        headers: { 
            "accept": "*/*",
            "content-type": "application/json" 
        },
        body: JSON.stringify(ARegistry)
    });

    if (httpRes.status === 401) {
        // logout user
        throw {
            status: httpRes.status,
            message: await httpRes.text()
        };
    } else if (httpRes.status !== 200) {
        throw {
            status: httpRes.status,
            message: await httpRes.text()
        };
    }   

    const result = await httpRes.json();

    if (result.status !== undefined && result.status !== null) {
        throw new Error(result.message);
    }
}